<template>
    <div class="input-container info-inline">
        <label for="ProfessioneL1" v-html="label"></label>
        <div :class="{'e-select': true, 'customSelect': true, 'is-open': isOpen}">
            <span @click="onClickLabel()" ref="selectLabel" :class="{'e-select-opener': true, 'field-error': errors && errors.length > 0}" role="combobox" tabindex="0">
                <span v-if="internalValue">{{internalValue.label}}</span>
                <span v-else>-- Seleziona --</span>
            </span>
            <input type="hidden" v-model="internalValue" />
            <div class="e-select-panel" role="listbox" 
                v-closable="{handler: onClickOutside, exclude: ['selectLabel']}">
                <div
                    :class="{'e-select-option': true, 'is-selected': selectedIndex == -1, 'has-focus': selectedIndex == -1}"
                    @click="onItemClick(-1)"
                    @mouseover="onMouseOverItem(-1)"
                    role="option">
                    -- Seleziona --
                </div>
                <div
                    v-for="(value, index) in values" :key="index"
                    :class="{'e-select-option': true, 'is-selected': selectedIndex == index, 'has-focus': selectedIndex == index}"
                    @click="onItemClick(index)"
                    @mouseover="onMouseOverItem(index)"
                    role="option">
                    {{value.label}}
                </div>
            </div
        ></div>

        <ul class="parsley-errors-list filled" id="parsley-id-18"
            v-if="errors && errors.length > 0">
            <li v-for="(error, index) in errors" :key="index" 
                class="parsley-required">{{error}}</li>
        </ul> 
    </div>
</template>
<script>
import Closable from "@/directive/Closable.js";

export default{
    name: "mb-input-drop-down",
    directives: {
        Closable
    },
    props: {
        label: String,
        values: Array,
        value: {
            type: Object,
            default(){
                return {}
            }
        },
        errors: Array
    },
    data(){
        return {
            isOpen: false,
            selectedIndex: 0,
            internalValue: null
        }
    },
    watch: {
    },
    created() {
        if (!this.value || typeof this.value == 'undefined' || !this.value.label) {
            this.updateSelected(-1);
        }
    },
    methods: {
        onClickOutside(){
            this.isOpen = false;
        },
        updateSelected(index){
            this.selectedIndex = index
            this.isOpen = false
            this.internalValue = null
            if (index != -1 ){
                this.internalValue = this.values[index]
            }

            this.$emit('input', this.internalValue)
            this.$emit('change', this.internalValue)
        },
        onClickLabel(){
            this.isOpen = !this.isOpen;
        },
        onMouseOverItem(index){
            this.selectedIndex = index;
        },
        onItemClick(index){
            this.updateSelected(index);
        }
    }
}
</script>
<style scoped>
.input-container .field-error{
    border: 1px solid #b5161a;
}
</style>